import { Component, OnInit, ViewChild } from '@angular/core';
import { AbstractComponent } from '../../abstract-component';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import {
  MatTableModule,
  MatTable,
  MatTableDataSource,
} from '@angular/material/table';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatSort, MatSortModule } from '@angular/material/sort';
import { FormsModule } from '@angular/forms';
import { CommonModule, DecimalPipe } from '@angular/common';
import { Quote } from '../../model/quote';
import { Transaccion } from '../../model/transaccion';

@Component({
  selector: 'app-kafka',
  imports: [MatFormField, MatLabel, MatTableModule, MatPaginatorModule, MatSortModule, FormsModule, DecimalPipe],
  templateUrl: './kafka.component.html',
  styleUrl: './kafka.component.css'
})
export class KafkaComponent extends AbstractComponent implements OnInit {
  dataSource: MatTableDataSource<Quote>;
  columnsToDisplay = ["id", "price"];
  quotes: Quote[] = []

  dataSourceTransacciones: MatTableDataSource<Transaccion>;
  columnsTransacciones = ["transactionId", "importe", "bancoDestino"];
  transacciones: Transaccion[] = [];

  @ViewChild('paginatorQuotes') paginator!: MatPaginator;
  @ViewChild('paginatorTransacciones') paginatorTransacciones!: MatPaginator;

  constructor() {
      super();
      this.dataSource = new MatTableDataSource(this.quotes);  
      this.dataSourceTransacciones = new MatTableDataSource(this.transacciones);  
  }
  ngAfterViewInit(): void {
    //console.log(`ngAfterViewInit ${this.detalle.inputProperty}`);
    console.log(`**** Aplicando paginador paginador ${this.paginator}`)
    this.dataSource.paginator = this.paginator;
    if (this.paginator) {
      this.dataSource.paginator.firstPage();
    }
    
    this.dataSourceTransacciones.paginator = this.paginatorTransacciones;
    if (this.paginatorTransacciones) {
      this.dataSourceTransacciones.paginator.firstPage();
    }
  }
  onRequestQuote(){
    console.log('Requesting quote...');
    this.dhrService.requestKafkaQuote().subscribe({
      next: (response: string) => {
        console.log('Quote request sent:', response); 
        const quote: Quote = { id: response, price: 0 };
        this.quotes.push(quote);
        this.dataSource = new MatTableDataSource(this.quotes);  
        this.dataSource.paginator = this.paginator;
        this.dataSource.data = this.quotes;
      },
      error: (error) => {
        console.error('Error requesting quote:', error);
      }
    });
  }
  
  ngOnInit(): void {
    console.log('KafkaComponent initialized');
    this.dhrService.getServerSendEventQuotes().subscribe({
      next: (quote: Quote) => {
        console.log('Received quote:', quote);
        this.quotes.forEach((q) => {
          if (q.id === quote.id) {
            q.price = quote.price; // Actualiza el precio si ya existe
            return;
          }
        });
        // Si no se encontró, agrega la nueva cotización
        if (!this.quotes.some(q => q.id === quote.id)) {
          this.quotes.push(quote);
        }
        this.dataSource = new MatTableDataSource(this.quotes);
        this.dataSource.paginator = this.paginator;
        this.dataSource.data = this.quotes;
      },
      error: (error) => {
        console.error('Error receiving quotes:', error);
      }
    });

    this.dhrService.getServerSendEventStreamReceiver().subscribe({
      next: (transaccion: Transaccion) => {
        console.log('Received transaccion:', transaccion);
        
        let found = false;
        this.transacciones.forEach((t) => {
          if (t.transactionId === transaccion.transactionId) {
            t.importe = transaccion.importe;
            t.bancoDestino = transaccion.bancoDestino;
            found = true;
          }
        });

        if (!found) {
          this.transacciones.push(transaccion);
        }
        
        this.dataSourceTransacciones = new MatTableDataSource(this.transacciones);
        this.dataSourceTransacciones.paginator = this.paginatorTransacciones;
        this.dataSourceTransacciones.data = this.transacciones;
      },
      error: (error) => {
        console.error('Error receiving stream events:', error);
      }
    });
  }
  
  onRequestStreamProducer(){
    console.log('Calling stream producer...');
    this.dhrService.requestStreamProducer().subscribe({
      next: (response: any) => {
        console.log('Stream producer called successfully:', response); 
      },
      error: (error) => {
        console.error('Error calling stream producer:', error);
      }
    });
  }

  onOnDestroy() {
    console.log('KafkaComponent destroyed');
    if (this.subscriptions) {
      this.subscriptions.unsubscribe();
    }
  }
}
